import { render, staticRenderFns } from "./footprints.vue?vue&type=template&id=d39e2720"
import script from "./footprints.ts?vue&type=script&lang=js&external"
export * from "./footprints.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports